import { TApplicationState } from '../../types/redux';

export const selectConsultantPhone = (state: TApplicationState) => {
  return state.consultantContacts.phone;
};
